import { ReactElement } from 'react';
import { PAGE_ICONS } from 'pages/AnnualUserAccessReview/_const';
import PageWithBreadcrumbs from 'pages/AnnualUserAccessReview/layouts/UARPageWithBreadcrumbs';

/**
 * Statistics and metrics on manager's direct reports' review status
 * @returns {ReactElement} Summary of review status
 */
const Summary = () => {
	return (
		<PageWithBreadcrumbs
			currentPageLabel={'Annual Review Summary'}
			CurrentPageIcon={PAGE_ICONS.SUMMARY}
		>
			<>Annual Review Summary</>
		</PageWithBreadcrumbs>
	);
};

export default Summary;
